import type { QueryFunctionContext } from "@tanstack/query-core"
import type { AxiosResponse } from "axios"
import isNumber from "lodash-es/isNumber"

import { axiosClient } from "$/http"

import { extractNumberFromQueryKeyPart } from "@/3514/utils"

import {
    ESessionScheduleQueryKey as EQueryKey,
    ESessionScheduleQueryUrl as EQueryUrl
} from "./session-schedule.modal.api.config"
import { type ISessionScheduleCoachTimeWidgetQueryDto as ICoachTimeWidgetQueryDto } from "./session-schedule.modal.api.types"

export default {
    async coachTimeWidget({
        queryKey
    }: QueryFunctionContext<ReturnType<typeof EQueryKey.CoachTimeWidget>>): Promise<ICoachTimeWidgetQueryDto> {
        const coachId: number | null = extractNumberFromQueryKeyPart(queryKey[1])
        const sessionId: number = extractNumberFromQueryKeyPart(queryKey[2])

        if (!isNumber(coachId)) throw new Error(`Coach id is ${typeof coachId}; sessionId:${sessionId}`)

        const { data }: AxiosResponse<ICoachTimeWidgetQueryDto> = await axiosClient.get(
            EQueryUrl.CoachTimeWidget({
                coachId,
                sessionId,
                participantId: extractNumberFromQueryKeyPart(queryKey[3])
            })
        )

        return data
    }
}
